import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lp-item__kicker" }
const _hoisted_2 = { class: "lp-item__type" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "lp-item__dot" }, null, -1)

import HcIcon from '@/modern/components/ui/HcIcon.vue';
import { ResourceKind, useLearningPathI18n } from '../view/learningPath';
import type { INavEntry } from './usePathwayItemNav';


export default /*#__PURE__*/_defineComponent({
  props: {
    kind: null,
    current: null
  },
  setup(__props: any) {



const { tl } = useLearningPathI18n();

const KIND_ICON = { lesson: 'video', challenge: 'flag', machine: 'display' };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(HcIcon, {
        name: KIND_ICON[__props.kind],
        size: 14
      }, null, 8, ["name"]),
      _createTextVNode(_toDisplayString(_unref(tl)(`type_${__props.kind}`)), 1)
    ]),
    (__props.current)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_unref(tl)('item_position', {
        section: __props.current.sectionIndex + 1,
        index: __props.current.index + 1,
        total: __props.current.section.resources.length,
      })), 1)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})